(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var cookieBtn = document.getElementById('alertProgrammeBtn');
var alertProgramme = document.getElementById('alertProgramme');
var programmeId = alertProgramme.dataset.programmeId;
var cookieName = 'program-alert_' + programmeId;

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? true : false;
}

var displayAlertBlock = getCookie(cookieName);

if (!displayAlertBlock) {
  try {
    alertProgramme.classList.remove('hide');
    cookieBtn.addEventListener("click", function () {
      var date = new Date();
      date.setTime(date.getTime() + 2 * 60 * 60 * 1000);
      document.cookie = "".concat(cookieName, "=true; expires=").concat(date.toGMTString(), "; path=/");
      alertProgramme.classList.add("hide");
    });
  } catch (e) {
    console.error("Erreur : ", e);
  }
}

},{}]},{},[1]);
